/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { FxIdDomainSettingsFxEventsClientPublicConfigConfigSectionFromJSON, FxIdDomainSettingsFxEventsClientPublicConfigConfigSectionToJSON, } from './FxIdDomainSettingsFxEventsClientPublicConfigConfigSection';
/**
 * Check if a given object implements the FxIdDomainSettingsFxEventsClientPublicConfig interface.
 */
export function instanceOfFxIdDomainSettingsFxEventsClientPublicConfig(value) {
    if (!('SendAllToGtag' in value) || value['SendAllToGtag'] === undefined)
        return false;
    if (!('Sections' in value) || value['Sections'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsFxEventsClientPublicConfigFromJSON(json) {
    return FxIdDomainSettingsFxEventsClientPublicConfigFromJSONTyped(json, false);
}
export function FxIdDomainSettingsFxEventsClientPublicConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SendAllToGtag': json['SendAllToGtag'],
        'Sections': (mapValues(json['Sections'], FxIdDomainSettingsFxEventsClientPublicConfigConfigSectionFromJSON)),
    };
}
export function FxIdDomainSettingsFxEventsClientPublicConfigToJSON(json) {
    return FxIdDomainSettingsFxEventsClientPublicConfigToJSONTyped(json, false);
}
export function FxIdDomainSettingsFxEventsClientPublicConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SendAllToGtag': value['SendAllToGtag'],
        'Sections': (mapValues(value['Sections'], FxIdDomainSettingsFxEventsClientPublicConfigConfigSectionToJSON)),
    };
}
//# sourceMappingURL=FxIdDomainSettingsFxEventsClientPublicConfig.js.map